import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "@/plugins/i18n";
import { authGuard } from "@tt/vue-auth0";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: "/routes",
  },
  {
    path: "/routes",
    name: "RoutesView",
    component: () => import("@/views/RoutesView"),
    meta: {
      label: i18n.tc("routes.title", 2),
      active: true,
    }
  },
  {
    path: "/targets",
    name: "TargetsView",
    component: () => import("@/views/TargetsView"),
    meta: {
      label: i18n.tc("targets.title", 2),
      active: true,
    }
  },
  {
    path: "/delays",
    name: "DelaysView",
    component: () => import("@/views/DelaysView"),
    meta: {
      label: i18n.tc("delays.title", 2),
      active: true,
    }
  },
  {
    path: "/test",
    name: "TestView",
    component: () => import("@/views/TestView"),
    meta: {
      label: i18n.tc("test.overview.title", 2),
      active: true,
    }
  }
];

// create router
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// auth check
router.beforeEach(authGuard);

export default router;
